import { getPredictionRoundResult } from '@store:web/components/pages/MagicPredictionsPage/model/AdjacentRound/roundState';
import { RoundResult } from '@store:web/components/pages/MagicPredictionsPage/model/RoundResult';
import { DialogButton } from '@ui/uikit/components/common/Dialog';
import { Prediction } from '@ui/uikit/components/icons/mono/Prediction';

import type { PredictionButtonProps } from './ButtonProps';

export const ClosedPredictionButton = ({ participation, round }: PredictionButtonProps) => {
  if (!participation.isParticipated) {
    return (
      <DialogButton variant="secondary" isDisabled>
        You didn&apos;t bet in this round
      </DialogButton>
    );
  }

  if (getPredictionRoundResult(round) === RoundResult.DRAW) {
    return (
      <DialogButton variant="secondary" isDisabled>
        Your entry has been refunded
      </DialogButton>
    );
  }

  if (participation.wonAmount.value <= 0) {
    return (
      <DialogButton variant="secondary" isDisabled>
        You bet on {participation.directionTitle} • No reward
      </DialogButton>
    );
  }

  return (
    <button className="msq-btn msq-btn-lg bg-base-bg-secondary-orange rounded-xl" disabled>
      <div className="flex gap-2 items-center">
        <Prediction className="icon-xs text-base-text-orange" />
        <div>You Won {participation.wonAmount?.formatted}!</div>
      </div>
    </button>
  );
};
